import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class PuntOutOfBounds extends Fragment {
    constructor() {
        super();

        this.code = "OB";
    }

    summarize(summaryContext, stringifier) {
        const message = `out-of-bounds at the 		
		${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            summaryContext.fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }
}
